import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';

import {ApplicationState} from '../../application-state/store';
import {CustomerTypesActions} from '../store';
import {CustomerTypesSelectors} from '../store/selectors';

@Injectable()
export class CustomerTypesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadCustomers().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCustomers() {

    return this.store.pipe(
      select(CustomerTypesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CustomerTypesActions.LoadCustomerTypes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
